 export class SubjectAttendence {


public attendence_id: number;
public subject_id: number;
public job_id: number;
public created_by: string;
public created_date: string;
public who_attended: number;
public date_attended: any;
public time_attended: any;
public note_content: string;
   attendence_number: number;



/*
attendence_id
subject_id
job_id
created_by
created_date
who_attented
date_attended
time_attended
note_content
*/


  }

